/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { FunctionComponent, ReactElement } from 'react'
import { ViewProps } from 'react-native'

import { ColorsType, TextColorKey } from 'theme/types'
import { AccessibleIcon } from 'ui/svg/icons/types'

export enum TagVariant {
  DEFAULT = 'default',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  HIGHLIGHT = 'highlight',
  BOOKCLUB = 'bookclub',
  CINECLUB = 'cineclub',
  SCENECLUB = 'sceneClub',
  HEADLINE = 'headline',
  LIKE = 'like',
}

export type TagProps = ViewProps & {
  label: string
  variant?: TagVariant
  Icon?: FunctionComponent<AccessibleIcon> | ReactElement
  isMultiline?: boolean
}

export type TagColorStyles = {
  backgroundColor: ColorsType
  iconColor: ColorsType
  labelColor: TextColorKey
  iconSize: number
}
